import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CouponType } from '@src/types/coupons'

export const initialState = {
  isLoading: false,
  coupons: [] as CouponType[],
  isNext: false,
  total: 0,
}

const couponsSlice = createSlice({
  name: 'coupons',
  initialState,
  reducers: {
    setIsLoading(state, { payload }: PayloadAction<boolean>) {
      state.isLoading = payload
    },
    setCoupons(state, { payload }: PayloadAction<CouponType[]>) {
      state.coupons.push(...payload)
    },
    setIsNext(state, { payload }: PayloadAction<boolean>) {
      state.isNext = payload
    },
    setTotal(state, { payload }: PayloadAction<number>) {
      state.total = payload
    },
    resetCoupons: () => initialState,
  },
})

export type CouponsStateType = typeof initialState

export const {
  setIsLoading, setCoupons, setIsNext, setTotal, resetCoupons,
} = couponsSlice.actions
export const couponsReducer = couponsSlice.reducer
